// extracted by mini-css-extract-plugin
export default {"cls1":"AddPayeeError-Button_cls1__vCWGQ","cls2":"AddPayeeError-Button_cls2__m3Wo0 AddPayeeError-Button_cls1__vCWGQ"};